import { EDjangoAppsEndpoints } from '../enums/EDjangoAppsEndpoints';
import { type IAugmentedBackendResponse } from '../models/IAugmentedBackendResponse';
import { type ISortingMeta } from '../models/ISortingMeta';
import { type TPandasTable } from '../models/TPandasTable';
import ApiService from './apiService';

export class SvFactsheetLinksServices extends ApiService {
  static async getFactsheetLinksSnapshot(params: {
    page: number;
    sorting: ISortingMeta;
    search?: string;
  }) {
    return await super.get<IAugmentedBackendResponse<TPandasTable>>(EDjangoAppsEndpoints.factsheet, 'links', {
      page: params.page,
      sortCol: params.sorting.sortCol,
      ascending: params.sorting.ascending,
      search: params.search ?? '',
    });
  }

  static async getFactsheetInquiryLinksSnapshot(params: {
    page: number;
    sorting: ISortingMeta;
    search?: string;
  }) {
    return await super.get<IAugmentedBackendResponse<TPandasTable>>(EDjangoAppsEndpoints.factsheet, 'admin/inquiry', {
      page: params.page,
      sortCol: params.sorting.sortCol,
      ascending: params.sorting.ascending,
      searchText: params.search ?? '',
    });
  }
}
